import React from 'react';
import { Modal } from "react-bootstrap";
import LoginView from './Components/LoginView'
import '../../css/login.css';
import { getLabel } from "../../language";
import SignUpView from "./Components/SignUpView";
import voteIcon from "../../images/vote_icon.svg";

export class UserModal extends React.Component {
    constructor() {
        super();
        this.state = {
            email: "",
            password: "",
            rememberMe: "",
            signUpSuccess: "",
            view: 'login'
        }
    }

    signUpModalOpen = () => {
        this.setState({
            view: 'signup'
        })
    }

    onCloseAuthModal = () => {
        this.setState({
            view: 'login'
        });
        this.props.onCloseAuthModal();
    }

    render() {
        return (
            <Modal className="modal fade bd-example-modal-lg modal-user" show={this.props.isAuthModalOpen} onHide={this.onCloseAuthModal}>
                <div id="logincontent">
                    <section id="loginsection">
                        <div className="bcg">
                            <div className="hsContainer container">
                                <div className="hsContent">
                                    <Modal.Header>
                                        <Modal.Title>
                                            <p className="text-blue">{this.state.view === 'signup' ? getLabel(11) : getLabel(4)}</p>
                                        </Modal.Title>
                                        <button type="button" className="close" data-dismiss="modal"
                                            onClick={this.onCloseAuthModal}>×
                                        </button>
                                    </Modal.Header>
                                    <header>
                                        <img src={voteIcon} title="politiq" className="logo" alt="" />
                                        <h4 className="handwritten">...{getLabel(0)}</h4>
                                    </header>
                                    {
                                        this.state.view === 'signup' ?
                                            <SignUpView onCloseAuthModal={this.onCloseAuthModal} onLoginModal={() => this.setState({ view: 'login' })} /> :
                                            <LoginView onCloseAuthModal={this.onCloseAuthModal} />
                                    }

                                    {
                                        this.state.view === 'login' && <form>
                                            <p onClick={this.signUpModalOpen} className="signuplink pointer">
                                                {getLabel(5)}
                                            </p>
                                        </form>
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </Modal>
        );
    }
}

export default UserModal